export default __webpack_public_path__ + "alberta-not-available.3f084a87791775ab8574.svg";